import script from "./BilibiliLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./BilibiliLogin.vue?vue&type=script&setup=true&lang=js"

import "./BilibiliLogin.vue?vue&type=style&index=0&id=5bbb06ae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bbb06ae"]])

export default __exports__